import { CLEAR_SELECTED_PRESET, FETCH_PRESETS, SET_SELECTED_PRESET, SET_ACTIVE_PRESET, CLEAR_ACTIVE_PRESET, SET_IGNORE_USER_THEME_OVERRIDES } from './ActionTypes';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import * as PresetClient from '../api/PresetClient';
const createAction = (type, payload) => Object.assign({
  type
}, payload);
export const fetchPresets = themePath => {
  return dispatch => {
    dispatch(createAction(FETCH_PRESETS, {
      requestStatus: RequestStatusTypes.PENDING
    }));
    return PresetClient.fetchPresets(themePath).then(response => {
      dispatch(createAction(FETCH_PRESETS, {
        requestStatus: RequestStatusTypes.SUCCEEDED,
        results: response.results
      }));
      return response.results;
    }, error => {
      dispatch(createAction(FETCH_PRESETS, {
        requestStatus: RequestStatusTypes.FAILED,
        error
      }));
      throw error;
    });
  };
};
export const setActivePreset = activeThemePresetId => {
  return {
    type: SET_ACTIVE_PRESET,
    activeThemePresetId
  };
};
export const clearActivePreset = () => {
  return {
    type: CLEAR_ACTIVE_PRESET
  };
};
export const setSelectedPreset = selectedThemePresetId => {
  return dispatch => {
    dispatch(createAction(SET_SELECTED_PRESET, {
      selectedThemePresetId
    }));
  };
};
export const clearSelectedPreset = () => {
  return dispatch => {
    dispatch(createAction(CLEAR_SELECTED_PRESET, {}));
  };
};
export const setIgnoreUserThemeOverrides = ignoreUserThemeOverrides => {
  return {
    type: SET_IGNORE_USER_THEME_OVERRIDES,
    ignoreUserThemeOverrides
  };
};